import { cn } from '@workspace/ui/lib/utils'
import { useState } from 'react'
import { Prose } from '../../components/prose'

export const RISK_DOT_COLOR = {
  critical: 'bg-red-400',
  high: 'bg-amber-400',
  moderate: 'bg-blue-400',
} as const

export function ExpandableSignal({
  title,
  content,
  dotColor,
}: {
  title: string
  content: string
  dotColor: string
}) {
  const [open, setOpen] = useState(false)
  const hasContent = content && content !== title

  return (
    <button
      type="button"
      onClick={() => hasContent && setOpen(!open)}
      className={cn(
        'group w-full rounded-lg bg-card px-4 py-2.5 text-left',
        hasContent && 'cursor-pointer transition-colors hover:bg-hover'
      )}
    >
      <div className="flex items-center gap-2.5">
        <span className={cn('size-2 shrink-0 rounded-full', dotColor)} />
        <span className="flex-1 text-sm text-white">{title}</span>
        {hasContent && (
          <span className="ml-2 text-xs text-muted-foreground/50">{open ? '▲' : '▼'}</span>
        )}
      </div>
      {open && hasContent && (
        <Prose className="mt-2 pl-[18px] text-xs leading-relaxed text-muted-foreground">
          {content}
        </Prose>
      )}
    </button>
  )
}
